module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vleg10-a363e0876c8148f9ad0c93f1dcffd4d7.jpg";